import React from 'react';
import { Absence } from '../../__generated__/graphql';
import { toMoment } from './Utils';

import AbsenceTimeDuration from './AbsenceTimeDuration';
import AbsenceDateDuration from './AbsenceDateDuration';
import { isMultiDayAndHourly } from '../../pages/Absences/components/MultiDayAbsenceDetails/logic';
import MultiDayAbsenceBtn from '../../pages/Absences/components/MultiDayAbsenceDetails/MultiDayAbsenceBtn';

type AbsenceProps = Pick<
  Absence,
  | 'Id'
  | 'flair__Type__c'
  | 'flair__Start_Date__c'
  | 'flair__Start_Time__c'
  | 'flair__Start_Date_Half_Day__c'
  | 'flair__End_Date__c'
  | 'flair__End_Time__c'
  | 'flair__End_Date_Half_Day__c'
>;

type Props = {
  absence: AbsenceProps;
  onMultiDayClick?: (absenceId: string) => void;
};

const AbsenceDuration: React.FC<Props> = ({ absence, onMultiDayClick }) => {
  const startDate = toMoment(
    absence.flair__Start_Date__c,
    absence.flair__Start_Time__c,
  );
  const endDate = toMoment(
    absence.flair__End_Date__c,
    absence.flair__End_Time__c,
  );

  const isMultiDayAbsence = isMultiDayAndHourly(absence);

  const timeDuration =
    isMultiDayAbsence && onMultiDayClick ? (
      <div className="mt-1">
        <MultiDayAbsenceBtn absenceId={absence.Id} onClick={onMultiDayClick} />
      </div>
    ) : (
      <AbsenceTimeDuration startDate={startDate} endDate={endDate} />
    );

  return (
    <>
      <AbsenceDateDuration startDate={startDate} endDate={endDate} />
      {timeDuration}
    </>
  );
};

export default AbsenceDuration;
